import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../api.service';
import { Comparison } from '../../comparison';
import { IListItemAdapter, StringAdapter } from '../select-list/select-list.component';
import { CriteriaValidationService } from '../../criteria-validation.service';

@Component({
  selector: 'app-molecular',
  templateUrl: './molecular.component.html',
  styleUrls: ['./molecular.component.css']
})
export class MolecularComponent implements OnInit {

  constructor(public api: ApiService, private validator: CriteriaValidationService) { }

  public listAdapter: IListItemAdapter = new StringAdapter();
  @Input() filterModel;

  ngOnInit() {
    if (this.filterModel.IsNot === undefined) {
      this.reset();
    }
  }

  reset() {
    this.filterModel.IsNot = false;
    delete this.filterModel.IsPositive;
    this.filterModel.Test = null;
    this.filterModel.TestResults = [];
  }

  onSelectionChange(entry) {
    console.log('onSelectionChange: ' + entry);
    this.filterModel.IsPositive = entry;
    if (entry !== null) {
      this.filterModel.TestResults = [];
    }
  }

  get isValid() {
    return this.validator.isMolFilterValid(this.filterModel);
  }

  compare(a, b) {
    return Comparison.equals(a, b);
  }

  get children() {
    if (!this.filterModel.Test) {
      return null;
    }

    return this.filterModel.Test.children.map(x => x.name);
  }

  get selectedTest() {
    return this.filterModel.Test;
  }
  set selectedTest(value) {
    if (value !== this.filterModel.Test) {
      this.filterModel.TestResults = [];
    }

    this.filterModel.Test = value;
    this.filterModel.IsPositive = undefined;
  }
}
